(function () {
  'use strict';
  function route(path, current, available, roots = {}) {
    const locales = new Map(available.map(code => [code.toLowerCase(), code]));
    const prefix = code => (roots[code] || (code === 'en' ? '/' : '/' + code)).replace(/\/$/, '');
    const existing = available.map(prefix).filter(Boolean).sort((a,b) => b.length-a.length).find(root => path.toLowerCase() === root.toLowerCase() || path.toLowerCase().startsWith(root.toLowerCase() + '/'));
    const bare = existing ? path.slice(existing.length) || '/' : path;
    const hub = bare.match(/^\/(?:pages\/)?books-in-([a-z-]+)\/?$/i);
    if (hub) {
      const code = locales.get(hub[1].toLowerCase());
      return (code ? prefix(code) : '') + '/pages/books-in-' + hub[1].toLowerCase();
    }
    // Respect an already-localized link; only repair root-relative legacy links.
    if (existing) return path;
    return current !== 'en' && /^\/(?:products|collections|pages|cart|search|account)(?:\/|$)/.test(bare) ? prefix(current) + bare : path;
  }
  if (typeof module !== 'undefined') { module.exports = { route }; return; }
  const node = document.getElementById('ca-language-context');
  if (!node) return;
  const context = JSON.parse(node.textContent);
  const current = context.locale;
  const available = context.available;
  const roots = context.roots || {};
  const url = new URL(location.href);
  // The existing localized signup form reads ?lang= before it initializes.
  if (/\/pages\/newsletter\/?$/.test(url.pathname) && current !== 'en' && !url.searchParams.has('lang')) {
    url.searchParams.set('lang', current);
    history.replaceState(history.state, '', url.pathname + url.search + url.hash);
  }
  const hub = url.pathname.match(/\/(?:pages\/)?books-in-([a-z-]+)\/?$/i);
  const preference = /\/pages\/unsubscribed\/?$/.test(url.pathname) ? url.searchParams.get('lang') : hub?.[1];
  const selected = available.find(code => code.toLowerCase() === preference?.toLowerCase());
  if (selected && selected !== current) {
    const bare = hub ? '/pages/books-in-' + hub[1].toLowerCase() : '/pages/unsubscribed';
    location.replace((roots[selected] || (selected === 'en' ? '/' : '/' + selected)).replace(/\/$/, '') + bare + url.search + url.hash);
    return;
  }
  function repairLinks(root) {
    root.querySelectorAll('a[href]').forEach(a => {
      const target = new URL(a.getAttribute('href'), location.href);
      if (target.origin !== location.origin && !(target.protocol === 'https:' && ['cassiealexander.com','www.cassiealexander.com'].includes(target.hostname))) return;
      const next = route(target.pathname, current, available, roots);
      if (/\/pages\/newsletter\/?$/.test(next) && current !== 'en' && !target.searchParams.has('lang')) target.searchParams.set('lang', current);
      if (next !== target.pathname || target.search !== new URL(a.href).search) a.setAttribute('href', next + target.search + target.hash);
    });
  }
  document.addEventListener('DOMContentLoaded', () => repairLinks(document));
  document.addEventListener('shopify:section:load', e => repairLinks(e.target));
})();
